<template>
  <div class="wrapper box box_v">
    <!--头部-->
    <page-head title="楼宇档案" :btn-list="btnList" :show-back="true" @handleBtn="handleBtn"></page-head>
    <Modal :closable="false" :mask-closable="false" v-model="entryModal" title="楼宇新增" width="650">
      <div slot="footer">
        <Button type="text" @click="cancelEdit()">取消</Button>
        <Button :loading="isLoadingEntry" type="primary" @click="handleSave()">保存</Button>
      </div>
      <buildingBaseForm :id="$route.query.id" ref="form"></buildingBaseForm>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "building",
  components: {
    pageHead : () => import("../../../components/head"),
    buildingBaseForm: () => import("./add")
  },
  props: {},
  data() {
    return {
      entryModal: false,
      isLoadingEntry: false,
      btnList: [
        {
          name: "新增",
          type: "add",
          loading: false
        },
        {
          name: "删除",
          type: "del",
          loading: false,
          btnType: "default"
        },
        {
          // , {
          name: "导出",
          type: "export",
          loading: false,
          btnType: "default"
        }
      ]
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleBtn(type) {
      if (type == "add") {
        this.entryModal = true;
      } else if (type == "del") {
      } else if (type == "export") {
      }
    },
    cancelEdit() {
      this.entryModal = false;
    },
    async handleSave() {
      this.isLoadingEntry = true;
      try {
        let res = await this.$refs.form.save();
        if (res) this.entryModal = false;
      } finally {
        this.isLoadingEntry = false;
      }
    }
  },
  created() {
    console.log(this.$store.state.streetorcommunityid)
    console.log(this.$route.query.id)
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
</style>
